import { SVGProps, Ref, forwardRef } from 'react';

export const AdjustmentsFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.072 7.9H1V6.1h3.072C4.348 4.441 5.453 3 8 3s3.652 1.441 3.928 3.1H23v1.8H11.928C11.652 9.56 10.546 11 8 11S4.348 9.559 4.072 7.9M16 13c2.547 0 3.652 1.441 3.928 3.1H23v1.8h-3.072C19.652 19.56 18.547 21 16 21s-3.652-1.441-3.928-3.1H1v-1.8h11.072C12.348 14.441 13.453 13 16 13"
                fill="currentColor"
            />
        </g>
    </svg>
));
AdjustmentsFilledSize24Glyph.displayName = 'AdjustmentsFilledSize24Glyph';
